module.exports = __webpack_public_path__ + "static/media/link-logo-row.a1d3227a.jpg";